/**
 * Builds the groupInfoDto object sent to the server for all GROUPS save actions:
 *   - updateGroupContentRatings
 *   - updateGroupStudentCriteriaComments
 *
 * The groupInfoDto is routing metadata only — it tells the server which
 * grading profiles and criteria are involved. Per-record routing is handled
 * by gradingProfileStudentId + gradingCriteria on each individual record.
 *
 * Confirmed shape from payload:
 * {
 *   teacherGradingProfile: "23208",      // string — own profile id, null if no own EPR
 *   teacherGradingCriteria: "165740",    // string — own criteria id, null if no own EPR
 *   teacherHomeroomGroups: [{ groupId: 2371 }],
 *   sharedGroupInfos: [{
 *     sharedGradingProfile: 23213,
 *     sharedGradingCriteria: 165775,
 *     sharedGroupId: 2370
 *   }]
 * }
 *
 * @param {Object} params
 * @param {Object|null} params.ownProfile
 *   From GroupContext.ownProfile:
 *   { gradingProfileId, gradingCriteriaId, homeroomGroupIds: number[] }
 *   null when the viewing teacher has no own EPR (shared-only teacher)
 * @param {Array} params.sharedGroups
 *   From GroupContext.sharedGroups:
 *   [{ groupId, sharedGradingProfile, sharedGradingCriteria }]
 *
 * @returns {GroupInfoDto}
 */
const buildGroupInfoDto = ({ ownProfile, sharedGroups }) => {
    const teacherHomeroomGroups = (ownProfile?.homeroomGroupIds ?? []).map((groupId) => ({ groupId }));

    const sharedGroupInfos = (sharedGroups ?? []).map((sg) => ({
        sharedGradingProfile: sg.sharedGradingProfile,
        sharedGradingCriteria: sg.sharedGradingCriteria,
        sharedGroupId: sg.groupId
    }));

    return {
        teacherGradingProfile: ownProfile?.gradingProfileId ?? null,
        teacherGradingCriteria: ownProfile?.gradingCriteriaId ?? null,
        teacherHomeroomGroups,
        sharedGroupInfos
    };
};

export default buildGroupInfoDto;
